import { render, staticRenderFns } from "./MortgageDocumentsCollectionPage.vue?vue&type=template&id=a8fa0088&scoped=true"
import script from "./MortgageDocumentsCollectionPage.vue?vue&type=script&lang=js"
export * from "./MortgageDocumentsCollectionPage.vue?vue&type=script&lang=js"
import style0 from "./MortgageDocumentsCollectionPage.vue?vue&type=style&index=0&id=a8fa0088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8fa0088",
  null
  
)

export default component.exports